import { render, staticRenderFns } from "./ContentTranslation.vue?vue&type=template&id=42df0596&"
import script from "./ContentTranslation.vue?vue&type=script&lang=js&"
export * from "./ContentTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports